module.exports = __webpack_public_path__ + "static/img/empty2.b9f4353.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/empty2.png
// module id = sG/p
// module chunks = 1